import React, { Fragment, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import moment from 'moment';

import * as actions from '../../store/actions/index';

import Button from '../UI/Buttons/Index';
import Navigation from '../UI/Navigation/Index';

const Create = (props) => {
  const [age, setAge] = useState(0);
  const [barangay, setBarangay] = useState('');
  const [barangayOptions, setBarangayOptions] = useState([]);
  const [beneFirstname, setBeneFirstname] = useState('');
  const [beneLastname, setBeneLastname] = useState('');
  const [beneMiddlename, setBeneMiddlename] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [civilStatus, setCivilStatus] = useState('SINGLE');
  const [contact, setContact] = useState('');
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [memberType, setMemberType] = useState(0);
  const [middlename, setMiddlename] = useState('');
  const [nickname, setNickname] = useState('');
  const [noOfChild, setNoOfChild] = useState(0);
  const [relationship, setRelationship] = useState('');
  const [occupation, setOccupation] = useState('');
  const [skills, setSkills] = useState('');

  const {
    onCreateMember,
    onResetMembers,
    onFetchBarangays,
    barangays,
    member,
    loading,
  } = props;
  let navigate = useNavigate();

  useEffect(() => {
    onFetchBarangays();
  }, [onFetchBarangays]);

  useEffect(() => {
    if (barangays) {
      const brs = barangays.map((b) => {
        setBarangay(barangays[0].id);
        return (
          <option key={b.id} value={b.id}>
            {b.name}
          </option>
        );
      });
      setBarangayOptions(brs);
    }
  }, [barangays]);

  useEffect(() => {
    if (member) {
      toast.success('Member is Created!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
        onClose: () => {
          navigate('/members/upload', { state: { id: member.id } });
          onResetMembers();
        },
      });
    }
  }, [member, navigate, onResetMembers]);

  const birthdateChangeHandler = (e) => {
    setBirthdate(e.target.value);
    if (moment(e.target.value).isValid()) {
      setAge(moment().diff(e.target.value, 'years'));
    }
  };

  const submitNewMemberHandler = (e) => {
    e.preventDefault();
    const data = {
      barangay: barangay,
      beneFirstname: beneFirstname,
      beneLastname: beneLastname,
      beneMiddlename: beneMiddlename,
      birthdate: birthdate,
      civilStatus: civilStatus,
      contact: contact,
      firstname: firstname,
      lastname: lastname,
      memberType,
      middlename: middlename,
      nickname: nickname,
      noOfChild: noOfChild,
      occupation: occupation,
      relationship: relationship,
      role: 'MEMBER',
      skills: skills,
    };
    onCreateMember(data);
  };

  return (
    <Fragment>
      <Navigation />
      <ToastContainer />
      <div className="container mt-6 w-full">
        <form onSubmit={submitNewMemberHandler}>
          <h5 className="w-full md:w-1/2 ml-5 mt-5 px-3 mb-6 md:mb-0 text-2xl font-bold">
            Add New Member
          </h5>
          <div className="relative overflow-x-auto shadow-md bg-white">
            <div className="flex flex-wrap -mx-auto mb-6 px-6 py-4">
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="lastname"
                >
                  Lastname
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="lastname"
                  name="lastname"
                  type="text"
                  onChange={(e) => setLastname(e.target.value)}
                  value={lastname}
                  required
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="lastname"
                >
                  Firstname
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="lastname"
                  name="lastname"
                  type="text"
                  onChange={(e) => setFirstname(e.target.value)}
                  value={firstname}
                  required
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="middlename"
                >
                  Middlename
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="middlename"
                  name="middlename"
                  type="text"
                  onChange={(e) => setMiddlename(e.target.value)}
                  value={middlename}
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="nickname"
                >
                  Nickname
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="nickname"
                  name="nickname"
                  type="text"
                  onChange={(e) => setNickname(e.target.value)}
                  value={nickname}
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="birthdate"
                >
                  Birthdate
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="birthdate"
                  name="birthdate"
                  type="date"
                  onChange={birthdateChangeHandler}
                  value={birthdate}
                  required
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="birthdate"
                >
                  Age
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="age"
                  name="age"
                  type="number"
                  value={age}
                  required
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="civilStatus"
                >
                  Civil Status
                </label>
                <select
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="civilStatus"
                  name="civilStatus"
                  type="text"
                  onChange={(e) => setCivilStatus(e.target.value)}
                >
                  <option key="1" value="SINGLE">
                    SINGLE
                  </option>
                  <option key="2" value="MARRIED">
                    MARRIED
                  </option>
                  <option key="3" value="WIDOWED">
                    WIDOWED
                  </option>
                  <option key="4" value="LEGALLY SEPERATED">
                    LEGALLY SEPERATED
                  </option>
                  <option key="5" value="LIVE IN">
                    LIVE IN
                  </option>
                </select>
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="contact"
                >
                  Contact
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="contact"
                  name="contact"
                  type="text"
                  onChange={(e) => setContact(e.target.value)}
                  value={contact}
                />
              </div>
              <div className="md:w-1/3 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="occupation"
                >
                  Occupation
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="occupation"
                  name="occupation"
                  type="text"
                  onChange={(e) => setOccupation(e.target.value)}
                  value={occupation}
                />
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="skills"
                >
                  Skills/ Part Time Job
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="skills"
                  name="skills"
                  type="text"
                  onChange={(e) => setSkills(e.target.value)}
                  value={skills}
                />
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="barangay"
                >
                  Barangay
                </label>
                <select
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="barangay"
                  name="barangay"
                  type="text"
                  onChange={(e) => setBarangay(e.target.value)}
                >
                  {barangayOptions}
                </select>
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="memberType"
                >
                  Membership type
                </label>
                <select
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="memberType"
                  name="memberType"
                  type="text"
                  onChange={(e) => setMemberType(e.target.value)}
                >
                  <option key="0" value={0}>
                    Regular
                  </option>
                  <option key="1" value={1}>
                    Premium
                  </option>
                </select>
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="noOfChild"
                >
                  Number of Children
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="noOfChild"
                  name="noOfChild"
                  type="number"
                  onChange={(e) => setNoOfChild(e.target.value)}
                  value={noOfChild}
                />
              </div>
            </div>
            <h5 className="w-full md:w-1/2 ml-5 mt-5 px-3 mb-0 md:mb-0 text-2xl font-bold">
              Beneficiary Information
            </h5>
            <div className="flex flex-wrap -mx-auto mb-6 px-6 py-4">
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="beneLastname"
                >
                  Lastname
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="beneLastname"
                  name="beneLastname"
                  type="text"
                  onChange={(e) => setBeneLastname(e.target.value)}
                  value={beneLastname}
                  required
                />
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="beneFirstname"
                >
                  Firstname
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="beneFirstname"
                  name="beneFirstname"
                  type="text"
                  onChange={(e) => setBeneFirstname(e.target.value)}
                  value={beneFirstname}
                  required
                />
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="beneMiddlename"
                >
                  Middlename
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="beneMiddlename"
                  name="beneMiddlename"
                  type="text"
                  onChange={(e) => setBeneMiddlename(e.target.value)}
                  value={beneMiddlename}
                />
              </div>
              <div className="md:w-1/4 w-full px-3 mb-6 md:mb-4">
                <label
                  className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                  htmlFor="relationship"
                >
                  Relationship
                </label>
                <input
                  className="block appearance-none w-full border border-gray-200 text-gray-700 py-3 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="relationship"
                  name="relationship"
                  type="text"
                  onChange={(e) => setRelationship(e.target.value)}
                  value={relationship}
                />
              </div>
              <div className="w-full px-1 mb-12 md:mb-0">
                <div className="flex justify-end">
                  <Button type="submit" className="mt-6" disabled={loading}>
                    {loading ? 'Please Wait...' : 'Save Member'}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    barangays: state.barangays.barangays,
    member: state.members.member,
    loading: state.members.loading,
    error: state.members.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateMember: (data) => dispatch(actions.createMember(data)),
    onFetchBarangays: () => dispatch(actions.fetchAllBarangays()),
    onResetMembers: () => dispatch(actions.resetMembers()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Create);
